import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TuiTextfieldControllerModule, TuiTextareaModule, TuiInputModule } from '@taiga-ui/legacy';
import { TuiBadge, TuiButtonLoading } from '@taiga-ui/kit';
import { TuiLoader, TuiGroup, TuiIcon, TuiButton, TuiHint } from '@taiga-ui/core';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '@src/app/components';

import { IconModule } from '../icon';

import { GeocoderDialogComponent, GeocoderFormComponent, GeocoderFormFieldComponent } from './components';
import { GeocoderComponent } from './geocoder.component';

@NgModule({
  declarations: [GeocoderComponent, GeocoderFormComponent, GeocoderFormFieldComponent, GeocoderDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    TuiInputModule,
    TuiIcon,
    TuiLoader,
    TranslateModule,
    TuiButton,
    ...TuiHint,
    TuiTextfieldControllerModule,
    IconModule,
    TuiBadge,
    TuiGroup,
    TuiTextareaModule,
    TuiButtonLoading,
  ],
  exports: [GeocoderComponent],
})
export class GeocoderModule {}
